import { atom } from 'recoil';

export const replaceAgentForm = atom({
  key: 'replaceAgentForm', // unique ID (with respect to other atoms/selectors)
  default: {
    fname: '',
    lname: '',
    email: '',
    calleridNumber: '',
    callerid: '',
    smsNumber: '',
  },
  // default value (aka initial value)
});
